import { useQuery } from '@pinia/colada';

import { TeamSubject } from '../dtos/property-team.dto.interface';
import propertyTeamService, { teamServiceFor } from '../services/property-team.service';

export function getPropertyTeamQueryKey(subject: TeamSubject) {
  return [subject.kind, subject.id, 'team'];
}

/** Every unit's and building's team at once, for a change that moves people across them (a seat's removal) */
export function isPropertyTeamQuery(entry: { key: readonly unknown[] }): boolean {
  return (entry.key[0] === 'property' || entry.key[0] === 'building') && entry.key[2] === 'team';
}

/** Reads nothing until there is a subject */
export function usePropertyTeamQuery(subject: () => TeamSubject | null) {
  const current = () => subject() ?? { kind: 'property' as const, id: '' };

  return useQuery({
    key: () => getPropertyTeamQueryKey(current()),
    enabled: () => Boolean(current().id),
    query: () => teamServiceFor(current()).getTeam(current().id),
  });
}

export const accessRequestsToAnswerQueryKey = 'access-requests-to-answer';

/** The requests to work on a unit that wait on the caller, for the home page's actions */
export function useAccessRequestsToAnswerQuery() {
  return useQuery({
    key: () => [accessRequestsToAnswerQueryKey],
    query: () => propertyTeamService.accessRequestsToAnswer(),
  });
}
